var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"app-content"},[_c('div',{staticClass:"app-title"},[_c('div',[_c('h1',[_c('font-awesome-icon',{attrs:{"icon":"credit-card"}}),_vm._v("\r\n                    "+_vm._s(_vm.$t('title'))+"\r\n                ")],1)])]),_c('credit-deposit-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }